import { createEffect } from 'effector';
import { getAgentDashboardData } from '../api';

export const getAgentDashboardDataFx = createEffect(async (args: any) => {
  return await getAgentDashboardData(args).then((data) => data.data);
});
